import { render, staticRenderFns } from "./SelectCollecting.vue?vue&type=template&id=7bc5001e"
import script from "./SelectCollecting.vue?vue&type=script&lang=js"
export * from "./SelectCollecting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports